import wixWindow from 'wix-window';

var dur = 400
var dur2 = 400
var del = 0
var dir = "top"
var dir2 = "bottom"
var type = "fly"
var type2 = "fly"
let left = {
	"duration": 400,
	"delay": 0,
	"direction": "left"
};
let bottom = {
	"duration": 400,
	"delay": 0,
	"direction": "bottom"
};
let top = {
	"duration": 600,
	"delay": 0,
	"direction": "top"
};
let right = {
	"duration": 400,
	"delay": 0,
	"direction": "right"
};
let fade = {
	"duration": 400,
	"delay": 100,

}
var anima = {
	"duration": dur,
	"delay": del,
	"direction": dir,

}
let anima2 = {
	"duration": dur2,
	"delay": 0,
	"direction": dir2,
}
var url1 = "https://www.hadasaspis.co.il/portfoliofullview/"
var itemIndex
var windowHeight
var windowWidth
var Gin = 0
$w.onReady(function () {


	if (wixWindow.rendering.env === "browser") {
		start()
	}

	$w("#Rclick").onItemReady(($item, itemData, index) => {
const repeatedI = $item("#BR2")
		repeatedI.onClick((event) => {
$w("#Rclick").forEachItem(($item1, itemData1, index1) => {
		$item1("#BR2").expand().then(() => {
			$item1("#BR2").show("fade", fade)
		});});
			
			$item("#BR2").hide("fade", fade).then(() => {
//	$item("#BR2").collapse()
	});
			
			$w("#play").play();
			let scope = $w.at(event.context);
			var currentPost = scope('#dataset5').getCurrentItem();
			let textarry = (currentPost.itemcode).split(",")
		
			//CollapsAll("i", textarry)
	hideshow(textarry[0])
			$item("#"+textarry[0]).scrollTo()
		});

	});
	$w("#Rslide").onItemReady(($item, itemData, index) => {

		$item("#Bslide").onViewportEnter((event) => {

			$w("#play").play();
			let scope = $w.at(event.context);
			var currentPost = scope('#dataset5').getCurrentItem();

			let textarry = (currentPost.itemcode).split(",")
//CollapsAll("i", textarry)
	hideshow(textarry[0])
			$item("#"+textarry[0]).scrollTo()


		});	

		});
	

	$w("#repeater2").onItemReady(($item2, itemData2, index2) => {

		const repeatedI = $item2("#R2I")

		repeatedI.onMouseIn((event) => {

			
			if ($item2("#R2B2").hidden) {
				$item2("#R2B2").show("fly", right)
				$item2("#R2T2").show("fly", bottom)
			}

		});

		//repeatedI.onViewportEnter((event) => {
		//	$item2("#R2B2").show("fly", bottom).then(() => {
		//		$item2("#R2B2").hide("fade", fade)
		//	});

	//	});
		repeatedI.onMouseOut((event) => {

			$item2("#R2B2").hide("fade", fade)
			$item2("#R2T2").hide("fly", bottom)

		});
		repeatedI.onClick((event) => {
			if (!($item2("#R2B2").hidden)) {
				wixWindow.getBoundingRect()
					.then((windowSizeInfo) => {
						let documentHeight = windowSizeInfo.document.height; // 780
						let documentWidth = windowSizeInfo.document.width; // 1269

						wixWindow.openModal(url1 + itemData2.title, {
							"width": documentWidth,
							"height": documentHeight
						}).then(() => {

							$item2("#R2B2").hide("fly", right).then(() => {
								$item2("#R2B2").show("fly", right)
								$item2("#R2T1").text = "✓"
							});

						});
					});

			}
		});

	});
	$w("#repeater3").onItemReady(($item1, itemData1, index1) => {

		const repeatedI = $item1("#R1I")

		repeatedI.onMouseIn((event) => {

			
			if ($item1("#R1B1").hidden) {
				$item1("#R1B1").show("fly", right)
				$item1("#R1T1").show("fly", bottom)
			}

		});

		//repeatedI.onViewportEnter((event) => {
		//	$item2("#R2B2").show("fly", bottom).then(() => {
		//		$item2("#R2B2").hide("fade", fade)
		//	});

	//	});
		repeatedI.onMouseOut((event) => {

			$item1("#R1B1").hide("fade", fade)
			$item1("#R1T1").hide("fly", bottom)

		});
		repeatedI.onClick((event) => {
			if (!($item1("#R1B1").hidden)) {
				wixWindow.getBoundingRect()
					.then((windowSizeInfo) => {
						let documentHeight = windowSizeInfo.document.height; // 780
						let documentWidth = windowSizeInfo.document.width; // 1269

						wixWindow.openModal("https://www.hadasaspis.co.il" + itemData1.postPageUrl, {
							"width": documentWidth,
							"height": documentHeight
						}).then(() => {

							$item1("#R1B1").hide("fly", right).then(() => {
								$item1("#R1B1").show("fly", right)
								$item1("#R1T1").text = "✓"
							});

						});
					});

			}
		});

	});

});

function hideshow(itemid) {

	$w("#" + itemid).hide().then(() => {
		$w("#" + itemid).show("fade",fade)
	});

}

function CollapsHideITEM(itemid) {
	$w("#" + itemid).hide("fade", fade).then(() => {
		$w("#" + itemid).collapse()
	});

}

function ExpandShowITEM(itemid) {
	$w("#" + itemid).expand().then(() => {
		$w("#" + itemid).show("fly", bottom)
	});

}

function CollapsAll(itemid, textarry) {
	for (var i = 0; i < 8; i++) {
		if (!($w('#' + itemid + i).collapsed)) {
			$w("#" + itemid + i).hide()
			$w("#" + itemid + i).collapse()
		}
	}
	ExpandShowArry(textarry)
}

function ExpandShowArry(itemid) {
	$w("#play").play();
	for (var i = 0; i < itemid.length; i++) {

		$w("#" + itemid[i]).show("fade", fade)
		$w("#" + itemid[i]).expand()

	}

}

function ExpandAll(itemid) {
	for (var i = 0; i < 8; i++) {
		$w("#" + itemid + i).expand()
		$w("#" + itemid + i).show("fade", fade).then(() => {
		

		});
	}

}


function ShowITEM() {
	CollapsHideITEM("overlay")
	$w("#play").show(type2, anima2)

}

export function MENUitem_click(event) {
	CollapsHideITEM("overlay")
}

//************************************************
function start() {



}
//************************************************


export function i0_click(event) {
	
	hideshow("M1")
	hideshow("M0")

}
export function i1_click(event) {
	hideshow("M1")
	hideshow("M0")
}

export function i4_click(event) {

		hideshow("M1")
	hideshow("M0")
}

//************************************************

export function i0_viewportEnter(event) {
$w("#logo").show("fly", left)
$w("#POSmenu").hide("fly", right)

}

export function i0_viewportLeave(event) {
	$w("#logo").hide("fly", right)
	$w("#POSmenu").show("fly", right)
}

export function i6_viewportEnter(event) {
	$w("#logo").show("fly", left)
	$w("#POSmenu").hide("fly", right)
}

export function i6_viewportLeave(event) {
		$w("#logo").hide()
		$w("#POSmenu").show("fly", right)
}


export function R2_mouseOut(event) {
	CollapsHideITEM("Rclick")
}

export function Bcontact1_mouseIn(event) {
	hideshow(["i6"])
			$w("#i6").scrollTo()
	 
}

export function Bcontact_mouseIn(event) {
	hideshow(["i5"])
			$w("#i5").scrollTo()

}



export function Toverlay_click(event) {
	CollapsHideITEM("Toverlay")
}










export function M0_click(event) {
ExpandShowITEM("Rslide")
ExpandShowITEM("OVERLAY")
CollapsHideITEM("Rclick")
}

export function M1_click(event) {

CollapsHideITEM("M1")
ExpandShowITEM("Rclick")
$w("#Rclick").forEachItem(($item1, itemData1, index1) => {
		$item1("#BR2").expand().then(() => {
			$item1("#BR2").show("fade", fade)
		});
		});
	CollapsHideITEM("Rslide")
}


export function OVERLAY_click(event) {
CollapsHideITEM("OVERLAY")
ExpandShowITEM("M1")
CollapsHideITEM("Rslide")

}

export function Rclick_mouseOut(event) {
CollapsHideITEM("Rclick")
ExpandShowITEM("M1")

}



export function form11_viewportEnter(event) {
	hideshow("button14")
	hideshow("text94")
}